import styles from './MinimizeMaximizeArrows.module.scss';
import GreyArrowsInIcon from 'assets/images/grey-arrows-in.svg';
import GreyArrowsOutIcon from 'assets/images/grey-arrows-out.svg';
import BlackArrowsInIcon from 'assets/images/black-arrows-in.svg';
import BlackArrowsOutIcon from 'assets/images/black-arrows-out.svg';
import TealArrowsInIcon from 'assets/images/teal-arrows-in.svg';
import TealArrowsOutIcon from 'assets/images/teal-arrows-out.svg';
import PropTypes from 'prop-types';
import { useState } from 'react';

const MinimizeMaximizeArrows = ({
    isManualZoom = false,
    isFullView = false,
    toggleFullView,
    toggleDefaultView,
    toggleManualZoom
}) => {
    const [leftIconHovered, setLeftIconHovered] = useState(false);
    const [rightIconHovered, setRightIconHovered] = useState(false);

    const generateCommonImgElement = (
        iconSrc,
        arrowDirection = 'in',
        disabled = false
    ) => {
        return (
            <img
                src={iconSrc}
                alt={''}
                className={disabled ? styles.disabledIcon : styles.icon}
                onMouseOver={() =>
                    arrowDirection === 'in'
                        ? setLeftIconHovered(true)
                        : setRightIconHovered(true)
                }
                onMouseOut={() =>
                    arrowDirection === 'in'
                        ? setLeftIconHovered(false)
                        : setRightIconHovered(false)
                }
                onClick={() => {
                    if (isManualZoom) {
                        if (arrowDirection === 'in') {
                            toggleDefaultView();
                            toggleManualZoom(false);
                        } else {
                            toggleFullView();
                            toggleManualZoom(false);
                        }
                    }
                    if (isFullView) {
                        if (arrowDirection === 'in') {
                            toggleDefaultView();
                            toggleManualZoom(false);
                        }
                    }
                    if (!(isFullView && isManualZoom)) {
                        if (arrowDirection === 'out') {
                            toggleFullView();
                            toggleManualZoom(false);
                        }
                    }
                }}
            />
        );
    };
    const calculateLeftArrowsIconColor = () => {
        if (leftIconHovered && (isManualZoom || isFullView))
            return generateCommonImgElement(TealArrowsInIcon);
        if (isManualZoom || isFullView)
            return generateCommonImgElement(BlackArrowsInIcon);
        return generateCommonImgElement(GreyArrowsInIcon, 'in', true);
    };

    const calculateRightArrowsIconColor = () => {
        if (rightIconHovered && (isManualZoom || !isFullView))
            return generateCommonImgElement(TealArrowsOutIcon, 'out');
        if (isManualZoom || !isFullView)
            return generateCommonImgElement(BlackArrowsOutIcon, 'out');
        return generateCommonImgElement(GreyArrowsOutIcon, 'out', true);
    };

    return (
        <div className={styles.wrapper}>
            {calculateLeftArrowsIconColor()}
            {calculateRightArrowsIconColor()}
        </div>
    );
};

MinimizeMaximizeArrows.propTypes = {
    isManualZoom: PropTypes.bool,
    isFullView: PropTypes.bool,
    toggleFullView: PropTypes.func,
    toggleDefaultView: PropTypes.func,
    toggleManualZoom: PropTypes.func
};

export default MinimizeMaximizeArrows;
